<template>
  <v-dialog
    eager
    @update:model-value="change"
    :model-value="true"
    :max-width="width"
    :persistent="persistent"
    @keydown.esc="choose(undefined)"
  >
    <v-card
      rounded="lg"
      class="pa-8"
    >
      <div class="d-flex mb-4 align-center">
        <h3>
          {{ title }}
        </h3>
        <v-spacer />
        <v-icon
          v-if="showCancel"
          icon="close"
          @click="choose(undefined)"
        />
      </div>
      <div
        v-html="message"
        class="mb-8 text-secondary"
      />

      <div class="d-flex ga-4">
        <v-btn-secondary
          v-if="Boolean(buttonFalseText)"
          class="flex-grow-1"
          size="large"
          @click="choose(false)"
        >
          {{ buttonFalseText }}
        </v-btn-secondary>
        <v-btn-primary
          v-if="Boolean(buttonTrueText)"
          class="flex-grow-1"
          size="large"
          @click="choose(true)"
        >
          {{ buttonTrueText }}
        </v-btn-primary>
      </div>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">

export default {
  emits: ['close'],
  props: {
    buttonTrueText: {
      type: String,
      default: 'Proceed'
    },
    buttonFalseText: {
      type: String,
      default: 'Go back'
    },
    message: {
      type: String,
      required: true
    },
    persistent: Boolean,
    title: {
      type: String,
      default: undefined
    },
    width: {
      type: Number,
      default: 550
    },
    showCancel: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    document.addEventListener('keyup', this.onEnterPressed)
  },
  unmounted () {
    document.removeEventListener('keyup', this.onEnterPressed)
  },
  methods: {
    onEnterPressed (e) {
      if (e.keyCode === 13) {
        e.stopPropagation()
        this.choose(true)
      }
    },
    choose (value) {
      this.$emit('close', value)
    },
    change () {
      this.$emit('close', false)
    }
  }
}
</script>
<style scoped lang="scss">
</style>
